export default {"src":"/_next/static/media/entreprise_100_pour100_fr_mobil.1aeb51b9.svg","height":151,"width":148};